import { connect } from 'react-redux';

import { getIsHotelOnly } from 'src/store/view/selectors';
import { flightsCountSelector } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';

import {
  getOrderTouristsConfirmed,
  getOrderClientConfirmed,
  getIsFirstStepDone,
  getOrderIsFinished,
  getOrderFlightIsBusiness,
} from 'checkout/store/selectors/order';
import {
  goToPathAction,
  goToTouristsAction,
  goToClientAction,
} from 'checkout/store/actions/view';
import { getClientData } from 'src/store/client/selectors';
import { getIsHomePath } from 'checkout/store/selectors/router';
import { touristsSelector } from 'src/store/tourists/selectors';
import { getIsManualPackage } from 'checkout/store/selectors/package';
import { getSidebarTopMargin } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/actualize-alternatives';
import { transferMedInsuranceSelector } from 'checkout/store/selectors/tour';

import Sidebar from './Sidebar';

const mapStateToProps = (state) => ({
  clientData: getClientData(state),
  touristsData: touristsSelector(state),
  isBusinessFlight: getOrderFlightIsBusiness(state),
  isClientConfirmed: getOrderClientConfirmed(state),
  isTouristsConfirmed: getOrderTouristsConfirmed(state),
  isFirstStepDone: getIsFirstStepDone(state),
  isManualPackage: getIsManualPackage(state),
  isHomePath: getIsHomePath(state),
  isOrderFinished: getOrderIsFinished(state),
  flightsCount: flightsCountSelector(state),
  stickyOffset: getSidebarTopMargin(state),
  transferMedInsurance: transferMedInsuranceSelector(state),
  isHotelOnly: getIsHotelOnly(state),
});

const mapDispatchToProps = (dispatch) => ({
  goTo: (path) => dispatch(goToPathAction(path)),
  goToClient: () => dispatch(goToClientAction()),
  goToTourists: () => dispatch(goToTouristsAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
